import CardSdg from 'components/CardSdg';
import HorizontalCard from 'components/HorizontalCard';
import Layout from 'Layout'
import React from 'react'
// import IcHouse from 'assets/icons/ic-house.png'
// import IcBook from 'assets/icons/ic-book.png'
// import IcMedicine from 'assets/icons/ic-medicine.png'
// import IcMasjid from 'assets/icons/ic-masjid.png'
import { useState } from 'react';
import { useCallback } from 'react';
import { getFasilitasGampong, getSdg } from 'services/apiRoutes';
import { useEffect } from 'react';
import ImSdg from 'assets/images/im-sdg.jpg'
import { useParams } from 'react-router-dom';
// import ImSdg from "assets/images/ImSdg.jpg";



export default function Sdg() {
  const {slug}=useParams()
  const [sdg,setSdg]=useState();
  const [fasilitas,setFasilitas]=useState();

  const sdgAPI= useCallback(async ()=>{
    const res = await getSdg(slug);
    if (res.error) {
      return res.message;
    }else{
      const {data} = res.data;
      setSdg(data);
    }
  },[slug]);

  const fasilitasAPI = useCallback(async()=>{
    const res = await getFasilitasGampong(slug);
    if (res.error) {
      return res.message;
    }else{
      const {data} =res.data;
      setFasilitas(data);
    }
  },[slug])

  useEffect(() => {
    sdgAPI();
    fasilitasAPI();
  }, [sdgAPI, fasilitasAPI]);

  return (
    <Layout>
      <div className="px-5 xl:pt-44 py-28 kegiatan-wrapper xl:px-99">
        <h1 className="text-2xl font-bold mb-14 xl:text-7xl xl:mb-20">
          Sumber Daya Gampong
        </h1>
        <div className="space-y-24 wrapperCad">
          {sdg
            ? sdg.map((item, index) => (
                <HorizontalCard
                  key={index}
                  desc={item?.deskripsi}
                  title={item?.nama}
                  img={ImSdg}
                />
              ))
            : null}
        </div>
        <h1 className="my-20 text-3xl font-bold">Fasilitas Gampong</h1>
        <div className="grid-cols-2 gap-4 space-y-5 md:grid wrapperCardSdg">
          {fasilitas?.map((item) => (
            <CardSdg
              key={item.uuid}
              title={item?.nama}
              desc={item?.deskripsi}
              img={item?.url_gambar}
              h={80}
              w={80}
            />
          ))}
        </div>
      </div>
    </Layout>
  );
}
